export default __webpack_public_path__ + "static/media/colle_preview_m.af1fdf6f.png";